export default `uniform vec3 color;

void main() {
    vec2 xy = gl_PointCoord.xy - vec2(0.5);
    float ll = length(xy);
    gl_FragColor = vec4(color, step(ll, 0.5));
}`